import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import {
  Button,
  Checkbox,
  Col,
  Icon,
  Layout,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";
import { withNamespaces } from "react-i18next";

import classes from "./DocumentManagementDashboard.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDocumentDashboardRequiredStatusPerSiteRequest,
  getEtmfDocumentSchemaFilterRequest,
  getEtmfDocumentSchemaRequest,
  getSitesRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withParams } from "../../utils/url";
import forEach from "lodash/forEach";
import DocumentForm from "../../components/DocumentForm/DocumentForm";

const routes = require("../../routes.json");

class RequiredStatusPerSite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requiredStatusPerSite: [],
      sites: [],
      siteFilter: undefined,
      onlyMissingFilter: true,
      documentEdit: null,
      etmfSchema: {},
      etmfSchemaLimits: {},
      etmfSchemaFilters: {},
    };
  }

  async componentDidMount() {
    // this.getData();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      console.log(e);
    }

    this.getETMFSchema();
  }

  getETMFSchema = async () => {
    try {
      const { data: etmfSchema } = await getEtmfDocumentSchemaRequest();
      const {
        data: etmfSchemaFilter,
      } = await getEtmfDocumentSchemaFilterRequest(null, {
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });
      const etmfSchemaLimits = {};

      forEach(get(etmfSchema, "schema"), (category) => {
        forEach(category.sub_categories, (subCategory) => {
          forEach(subCategory.content_types, (contentTypes) => {
            if (
              contentTypes.limit_visibility_types &&
              contentTypes.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                contentTypes.limit_visibility_types;
            } else if (
              subCategory.limit_visibility_types &&
              subCategory.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                subCategory.limit_visibility_types;
            } else if (
              category.limit_visibility_types &&
              category.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                category.limit_visibility_types;
            }
          });
        });
      });

      this.setState({ etmfSchema, etmfSchemaLimits, etmfSchemaFilter });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  };

  getData = async () => {
    this.setState({ isLoading: true });
    try {
      const [requiredStatusPerSite] = await Promise.all([
        getDocumentDashboardRequiredStatusPerSiteRequest({
          site_id: this.state.siteFilter,
          only_missing: this.state.onlyMissingFilter,
        }),
      ]);
      this.setState({
        requiredStatusPerSite: requiredStatusPerSite.data,
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  };

  addDocumentWithParams = (documentEdit) => {
    this.setState({ documentEdit });
  };

  onDocumentEditHide = () => {
    this.setState({ documentEdit: null });
  };

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null, documentApproveId: null }, () => {
      this.getData();
    });
  };

  render() {
    const {
      isLoading,
      sites,
      documentEdit,
      etmfSchema,
      etmfSchemaLimits,
    } = this.state;

    const columns = [
      {
        dataIndex: "required_in",
        key: "required_in",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Required in"),
      },
      {
        dataIndex: "primary_category",
        key: "primary_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Primary Category"),
      },
      {
        dataIndex: "sub_category",
        key: "sub_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Sub Category"),
      },
      {
        dataIndex: "content_type",
        key: "content_type",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Content Type"),
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Status"),
      },
      {
        dataIndex: "number",
        key: "number",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Number"),
      },
      {
        dataIndex: "actions",
        key: "found_ids",
        width: "200px",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Actions"),
        render: (val, row) => (
          <div className={classes.actionsTableWrapper}>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                this.addDocumentWithParams({
                  primary_category_code: row.primary_category_code,
                  sub_category_code: row.sub_category_code,
                  content_type_code: row.content_type_code,
                  visibility: row.visibility_type,
                  site_id: row.site_id,
                });
              }}
            >
              {this.props.i18n.t("NamespaceDocumentsDashboard:Add document")}
            </Button>
            &nbsp; &nbsp;
            {row.found_ids.length > 0 && (
              <a
                href={withParams(routes.admin.documentsEditor, {
                  filter_by: "id__in",
                  filter_value: `"${row.found_ids.join(",")}"`,
                })}
                target="_blank"
              >
                <Button type="primary" size="small">
                  {this.props.i18n.t("NamespaceDocumentsDashboard:View")}
                </Button>
              </a>
            )}
          </div>
        ),
      },
    ];

    return (
      <div>
        <h4 className="headline-default">
          {this.props.i18n.t("NamespaceDocumentsDashboard:Required documents per site status")}
        </h4>

        <div className={classes.actionWrapper}>
          <h5 className="headline-default">{this.props.i18n.t("Filters")}</h5>

          <div className={classes.filterWrapper}>
            <div style={{ width: "300px" }}>
              <Select
                onChange={(val) => {
                  this.setState({ siteFilter: val }, this.getData);
                }}
                value={this.state.siteFilter || undefined}
                style={{ width: "300px" }}
                placeholder={this.props.i18n.t("Select site")}
                showSearch
                optionFilterProp="children"
                filterOption
                allowClear
              >
                {sites
                  .filter((site) => site.site_type === "randomization")
                  .sort(
                    (a, b) =>
                      +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                  )
                  .map((site) => (
                    <Select.Option key={site.id} value={site.id}>
                      {site.code} - {site.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
            &nbsp; &nbsp;
            <Checkbox
              onChange={() => {
                this.setState(
                  {
                    onlyMissingFilter: !this.state.onlyMissingFilter,
                  },
                  this.getData
                );
              }}
              checked={this.state.onlyMissingFilter}
            >
              {this.props.i18n.t("Only missing")}
            </Checkbox>
          </div>
        </div>

        {isLoading && <Icon type="loading" />}
        {!isLoading && (
          <div className={classes.tableWrapper}>
            <Table
              columns={columns}
              dataSource={this.state.requiredStatusPerSite}
              loading={isLoading}
              pagination={false}
              rowKey={() => uuidv4()}
            />
          </div>
        )}

        <Modal
          visible={!!documentEdit}
          onCancel={this.onDocumentEditHide}
          footer={null}
        >
          {documentEdit && (
            <DocumentForm
              {...documentEdit}
              blockCategories
              etmfSchema={etmfSchema}
              etmfSchemaLimits={etmfSchemaLimits}
              onSubmit={this.onDocumentEditSubmit}
              onCancel={this.onDocumentEditHide}
              isNew={documentEdit && !documentEdit.id}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(RequiredStatusPerSite))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentManagementDashboard/RequiredStatusPerSite.js